let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gkHQ4")).then(() => parcelRequire('j4I2w'));